// @ts-nocheck

window._ = require("lodash");

window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
}

import { i18n } from "./localization";
import nl from "vee-validate/dist/locale/nl.json";
import { localize } from "vee-validate";
localize({ nl });

import "lazysizes";

window.Vue = require("vue").default;

Vue.prototype.svg = require("./svg");

import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing);

Vue.use(require("vue-moment"));

import VClamp from "vue-clamp";
Vue.component("v-clamp", VClamp);


Vue.component("estates-slider", require("./components/estates/slider").default);
Vue.component("estates-filter", require("./components/estates/filter").default);
Vue.component("estate-status", require("./components/estates/status").default);
Vue.component("estate-price", require("./components/estates/price").default);
Vue.component("estate-search-bar", require("./components/estates/search-bar").default);
Vue.component("search-estate-form", require("./components/estates/search-form").default);
Vue.component("estate-map", require("./components/estates/map").default);

Vue.component("image-slider", require("./components/estates/image-slider").default);
Vue.component("image-lightbox", require("./components/estates/image-lightbox").default);
Vue.component("view-all-images", require("./components/estates/view-all-images").default);

Vue.component("projects-list", require("./components/projects/lists").default);
Vue.component("project-photo-grid", require("./components/projects/photo-grid").default);
Vue.component("project-units", require("./components/projects/units").default);

Vue.component("blog-slider", require("./components/blog/slider").default);
Vue.component("blog-page", require("./components/blog/page").default);
Vue.component("step-slider", require("./components/wordpress/step-slider").default);

Vue.component("wordpress-video", require("./components/wordpress/video").default);
Vue.component("wordpress-video-hero", require("./components/wordpress/video-hero").default);
Vue.component("wordpress-contact", require("./components/wordpress/contact").default);

Vue.component("hamburger-button", require("./components/elements/hamburger-button").default);
Vue.component("navigation-overlay", require("./components/elements/navigation-overlay").default);
Vue.component("typeform", require("./components/elements/typeform").default);
Vue.component("calendly-link", require("./components/elements/calendly-link.vue").default);
Vue.component("qr-code", require("./components/elements/qr-code.vue").default);

new Vue({
    i18n,
    el: "#app",
    lang: "nl",

    data: () => ({
        menuOpen: false,
        contactOpen: false,
        navigationIsVisible: false
    }),

    mounted() {
        this.$nextTick(() => {
            this.lang = document.documentElement.lang;
            const header: HTMLElement = document.querySelector(".main-header");
            const imageHero: HTMLElement = document.querySelector(".cover-cursor");

            if (imageHero) {
                imageHero.addEventListener("click", function(e) {
                    if (e.target.classList.contains("prevent-cover-cursor")) {
                        return;
                    }
                    e.preventDefault();
                    const btn = document.querySelector(".view-all-images-button");
                    btn.dispatchEvent(new Event("click"));
                });
            }

            window.onscroll = function() {
                if (header) {
                    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                        header.classList.add("scrolled");
                    } else {
                        header.classList.remove("scrolled");
                    }
                }
            };
        });
    },
    methods: {
        pushOrSlice(array: Array<string | number>, prop: string | number) {
            if (array.includes(prop)) {
                array.splice(array.indexOf(prop), 1);
            } else {
                array.push(prop);
            }

            return array;
        },
        disableScrolling(disable: boolean) {
            const body: HTMLElement = document.querySelector("body");

            if (disable) {
                body.classList.add("overflow-y-hidden");
            } else {
                body.classList.remove("overflow-y-hidden");
            }
        },
        openCalendly(url) {
            Calendly.initPopupWidget({ url: url, text: "Plan een afspraak", color: "#006bff", textColor: "#ffffff", branding: true });
        },
        toggleContact() {
            this.contactOpen = !this.contactOpen;
        }
    },
    computed: {
        possibleLangPrefix() {
            // prefix with lang other than nl for correct Weglot translations
            return document.documentElement.lang !== "nl" ? `/${document.documentElement.lang}` : "";
        }
    }
});

/**
 * Scrolling
 */

const scrollIntoView = require("scroll-into-view");
const scrollElements = document.querySelectorAll("a[href^='#']");

const headerHeight = document.getElementsByTagName("header").length > 0 ? document.getElementsByTagName("header")[0].clientHeight : 0;
const topOffset = window.innerWidth < 767.98 ? headerHeight + 150 : headerHeight + 120;

const scrollOptions = {
    align: {
        top: 0,
        topOffset: topOffset
    }
};

scrollElements.forEach(element => {
    if (element.getAttribute("href") !== "#") {
        element.addEventListener("click", function(e) {
            e.preventDefault();
            if (e.target.getAttribute("href") == null) {
                let target = e.target.closest("a").getAttribute("href");
                scrollIntoView(document.querySelector(target), scrollOptions, function() {
                    history.pushState({}, "", target);
                });
            } else {
                let target = e.target.getAttribute("href");
                scrollIntoView(document.querySelector(target), scrollOptions, function() {
                    history.pushState({}, "", target);
                });
            }
        });
    }
});
